import { Suspense } from 'react';
import { PageHeader } from 'components/PageHeader';
import { getTrans } from 'modules/i18n';
import { Layout } from 'modules/minimal-ui-theme';
import { LazyCopyTextSuccessToast } from 'modules/modals';
import { ContactZenjobContent } from 'modules/profile';

export const ContactZenjobPage = () => (
  <Layout
    header={
      <PageHeader title={getTrans('contactZenjobPage.title')} withBackBtn />
    }
  >
    <ContactZenjobContent />
    <Suspense>
      <LazyCopyTextSuccessToast />
    </Suspense>
  </Layout>
);
